import React, { useId, useState } from "react";
import {
  AccordionBlock,
  AccordionCard,
  AccordionContent,
  AccordionContentInner,
  AccordionLead,
  AccordionList,
  AccordionListItem,
  AccordionSection,
  AccordionSubtitle,
  AccordionText,
  AccordionTitle,
  ToggleButton,
  ToggleIcon,
} from "./AboutFapifyAccordion.styles";

const ABOUT_FAPIFY_SECTIONS = [
  {
    title: "AI porn generator with templates, undress AI, and NSFW AI workflows",
    paragraphs: [
      "Fapify is an AI porn generator with public AI porn templates, undress AI, image-to-video workflows, nudify-compatible edits, NSFW AI tools, and reusable AI girlfriend-style workflows. If you are searching for an AI porn generator that helps you move from idea to output faster, Fapify is built around reusable workflows instead of a generic blank shell.",
      "Instead of forcing every visitor to start from zero, Fapify connects template discovery, AI porn image creation, compatible image editing, and NSFW AI video generation inside one platform. That makes it easier to move from an idea to a finished result without jumping between separate tools.",
    ],
  },
  {
    title: "Why users choose Fapify for AI porn generation",
    list: [
      "Browse public AI porn templates instead of starting every workflow from a blank prompt.",
      "Use undress AI-compatible edits, AI nude workflows, and AI naked image refinement on supported templates.",
      "Turn still images into motion with image-to-video and NSFW AI video generation paths.",
      "Return to saved concepts, repeat winning setups, and build AI girlfriend-style persona workflows faster.",
    ],
  },
  {
    title: "Built for repeatable AI porn creation, not one-off prompts",
    paragraphs: [
      "Fapify is designed for users who need more than a one-off result. Whether you are testing new AI porn concepts, building repeatable NSFW AI workflows, or creating multiple variations of the same template, the platform is structured to help you generate consistently and keep your outputs easy to revisit.",
      "From template discovery to image editing to finished motion output, Fapify focuses on speed, reuse, and a polished generation flow. The goal is a smoother way to create, refine, and revisit the results you want.",
    ],
  },
];

const AboutFapifyAccordion = () => {
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();

  return (
    <AccordionSection>
      <AccordionCard>
        <ToggleButton
          type="button"
          aria-expanded={isOpen}
          aria-controls={contentId}
          onClick={() => setIsOpen((open) => !open)}
        >
          <AccordionTitle>About Fapify</AccordionTitle>
          <ToggleIcon $open={isOpen} aria-hidden="true" />
        </ToggleButton>

        <AccordionContent id={contentId} $open={isOpen}>
          <AccordionContentInner $open={isOpen}>
            <AccordionLead>
              Fapify is an AI porn generator focused on public AI porn
              templates, undress AI, image-to-video creation, compatible
              nudify edits, NSFW AI tools, and repeatable AI girlfriend-style
              workflows.
            </AccordionLead>

            {ABOUT_FAPIFY_SECTIONS.map((section) => (
              <AccordionBlock key={section.title}>
                <AccordionSubtitle>{section.title}</AccordionSubtitle>

                {section.paragraphs?.map((paragraph) => (
                  <AccordionText key={paragraph}>{paragraph}</AccordionText>
                ))}

                {section.list ? (
                  <AccordionList>
                    {section.list.map((item) => (
                      <AccordionListItem key={item}>{item}</AccordionListItem>
                    ))}
                  </AccordionList>
                ) : null}
              </AccordionBlock>
            ))}
          </AccordionContentInner>
        </AccordionContent>
      </AccordionCard>
    </AccordionSection>
  );
};

export default AboutFapifyAccordion;
